// extracted by mini-css-extract-plugin
module.exports = {"component":"Toast_component__1__Nt","success":"Toast_success__yT7qX","warn":"Toast_warn__226cU","error":"Toast_error__3hlm_"};